import { Action } from "@ngrx/store";
import { Admin } from "../models/Admin";

export enum AdminActionTypes {
	LoadAdmins = "[Admins Effects] Load Admins"
}

export class LoadAdmins implements Action {
	readonly type = AdminActionTypes.LoadAdmins;

	constructor(public payload: { admins: Admin[] }) {}
}

export type AdminsActions = LoadAdmins;
